"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 35 35", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M0 17.478C0 7.842 7.843 0 17.522 0 27.157 0 35 7.842 35 17.478 35 27.158 27.157 35 17.522 35 7.842 35 0 27.158 0 17.478z", fill: fill }),
            react_1.default.createElement("path", { d: "M25.135 9.602c0-1.703.852-2.286 1.21-2.286v-.313c-2.464 0-3.226-2.555-3.226-3.003h-.224c-.807 1.344-3.272 2.017-5.02 2.375-1.433.269-2.867.403-3.988.807-1.434.493-2.375 1.344-2.375 3.137v11.83c-.493-.627-1.3-.806-2.061-.806-.762 0-3.451.135-3.451 3.45 0 3.317 2.24 5.065 5.198 5.065 4.795 0 7.53-3.316 9.098-5.333v1.524c0 2.196 1.882 3.226 2.913 3.764l4.391-3.047-.358-.493s-.762.582-1.21.582c-.583 0-.897-.582-.897-.985V9.602z", fill: "#FFF" }),
            react_1.default.createElement("path", { d: "M16.262 9.109c0-.807.852-1.703 1.883-1.703 1.254 0 2.106.851 2.106 1.658v6.543h-3.989V9.109zM20.25 17.49v3.405c0 3.047-2.42 5.423-6.497 5.423-2.734 0-3.316-1.255-3.316-1.255.358.09.851.09 1.254.09 2.017 0 4.571-.718 4.571-3.317V17.49h3.989z", fill: fill }),
            react_1.default.createElement("path", { d: "M10.347 24.615v-.762c0-.628.269-1.076.851-1.076h.314v.852c0 .896-.672.986-1.165.986z", fill: fill }))));
};
var Ap = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#000C26' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill }, rest));
};
exports.default = Ap;
